<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TableList from '@/components/lists/TableList.vue'
import PageNavigation from '@/components/navigate/PageNavigation.vue'
import Progress from '@/components/forms/Progress.vue'
import { useCustomersStore } from '@/store/customers'
import { normalizeApiError } from '@/utils/apiError'

const store = useCustomersStore()
const router = useRouter()
const route = useRoute()
const currentPage = ref(Number(route.query.page) || 1)
const type = ref('')
const errorMessage = ref('')

const titles = ref([
  { title: 'Id', key: 'id' },
  { title: "Ім'я", key: 'name' },
  { title: 'Email', key: 'email' },
  { title: 'Телефон', key: 'phone' },
])

async function loadCustomers(page = currentPage.value) {
  type.value = 'loading'
  errorMessage.value = ''

  try {
    await store.getCustomers(page)
    type.value = ''
  } catch (error) {
    type.value = 'error'
    errorMessage.value = normalizeApiError(error, {
      fallbackMessage: 'Не вдалося завантажити список клієнтів.',
    }).message
  }
}

onMounted(async () => {
  await loadCustomers()
})

watch(currentPage, async (newPage) => {
  await router.push({ query: { page: newPage } })
  await loadCustomers(newPage)
})
</script>

<template>
  <Progress :type="type" :error-message="errorMessage" loading-message="Завантаження списку..." />
  <TableList :rows="store.allCustomers" :titles="titles" detailRoutName="CustomersDetail" blockTitle="Клієнти" />
  <PageNavigation v-model="currentPage" :totalPages="store.countPages" :maxVisible="5" />
</template>

<style scoped lang="scss">

</style>
